import { ExtendCSS, Flex } from 'vcc-ui';

import useColorChart from 'organisms/ColorChart/useColorChart';

const VerticalPalette = () => {
  const { colors: blueColors } = useColorChart('blue');
  const { colors: orangeColors } = useColorChart('orange');
  const { colors: redColors } = useColorChart('red');
  const { colors: greenColors } = useColorChart('green');

  const colors = [...blueColors, ...orangeColors, ...redColors, ...greenColors];

  return (
    <div>
      <Flex extend={paletteWrapperStyle}>
        {colors.map(({ colorModels: { hex: color } }) => (
          <Flex key={color} extend={{ flexGrow: 1, backgroundColor: color }} />
        ))}
      </Flex>
    </div>
  );
};

const paletteWrapperStyle: ExtendCSS = ({ theme: { baselineGrid } }) => ({
  flexDirection: 'row',
  height: baselineGrid * 24,
});

export default VerticalPalette;
